import Objekt from '@/models/objekt';
import Objektart from '@/models/objektart';
import Ort from '@/models/ort';
import Bezirk from '@/models/bezirk';
import Widmung from '@/models/widmung';
import Region from '@/models/region';
import TechnischeInfrastruktur from '@/models/technischeInfrastruktur';
import Glossar from '@/models/glossar';
import store from '@/store';
import axios from 'redaxios';

let loadingPromise;

export const loader = {
  methods: {
    load(silent) {
      if (!loadingPromise) {
        if (!silent) {
          // do not block UI when silent flaf is set
          this.$root.$emit('loading');
        }
        getContact();
        loadingPromise = Promise.all([
          axios.get('/api/objekt').then(({ data }) => {
            data.forEach(objekt => {
              objekt.geaendertam = new Date(objekt.geaendertam).getTime();
            });
            return Objekt.insertOrUpdate({ data });
          }),
          axios.get('/api/objektart').then(({ data }) => Objektart.insertOrUpdate({ data })),
          axios.get('/api/ort').then(({ data }) => Ort.insertOrUpdate({ data })),
          axios.get('/api/bezirk').then(({ data }) => Bezirk.insertOrUpdate({ data })),
          axios.get('/api/region').then(({ data }) => Region.insertOrUpdate({ data })),
          axios
            .get('/api/technischeInfrastruktur')
            .then(({ data }) => TechnischeInfrastruktur.insertOrUpdate({ data })),
          axios.get('/api/widmung').then(({ data }) => Widmung.insertOrUpdate({ data })),
          axios.get('/api/glossar').then(({ data }) => Glossar.insertOrUpdate({ data }))
        ]);
        loadingPromise
          .then(() => {
            this.$root.$emit('loaded');
            this.$store.commit('allLoaded');
          })
          .catch(e => {
            throw new Error('Database Sync Error: ' + e.message);
          });
      }
      return loadingPromise;
    },
    /**
     * re-loads data that is dependant on user data
     */
    reLoad(vm) {
      if (!loadingPromise) {
        // if no loading Promise is defined, no data has yet been loaded at all
        // the korrekt data will then be loaded at the initial load, when the data is needed
        return true;
      }
      vm.$root.$emit('loading');
      getContact();
      const reloadPromise = Promise.all([
        axios.get('/api/objekt').then(({ data }) => {
          data.forEach(objekt => {
            objekt.geaendertam = new Date(objekt.geaendertam).getTime();
          });
          return Objekt.insertOrUpdate({ data });
        })
      ]);
      reloadPromise
        .then(() => {
          vm.$root.$emit('loaded');
        })
        .catch(e => {
          throw new Error('Database Sync Error: ' + e.message);
        });
    }
  }
};

/**
 * if logged in, get the contact from crm
 * because of performance reason, this is seperate from the other requests.
 */
async function getContact() {
  const userdata = store.state.userdata;
  if (userdata?.id) {
    try {
      const response = await axios.get(`/api/contact/${userdata.id}`);
      await store.dispatch('contact', response.data);
    } catch (e) {
      await store.dispatch('contact', null);
    }
    return true;
  } else {
    await store.dispatch('contact', null);
    return true;
  }
}
